import { render, staticRenderFns } from "./CatalogDelete.vue?vue&type=template&id=5623f25c"
import script from "./CatalogDelete.vue?vue&type=script&lang=js"
export * from "./CatalogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports